import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { ProgressBar } from '@contrast-security-inc/design-system-data-bars'
import { useIntl } from 'react-intl'
import { formatStyles } from '../../../components/react-intl-helpers'
import { getServersFilteredRoute } from '../../../components/route'
import { ContrastProduct } from '../../../components/shared'
import { Link } from '@contrast-security-inc/design-system-typography'

export type ServerEnv = 'DEVELOPMENT' | 'QA' | 'PRODUCTION'

export interface Props {
  progress: number
  total: number
  product: ContrastProduct
  organizationUuid: string
  applicationId: string
  env: ServerEnv
}

export function ServerEnvProductBar({
  total,
  progress,
  product,
  organizationUuid,
  applicationId,
  env
}: Props) {
  const { formatMessage } = useIntl()

  const testId = `${env}-server-${product}-thermometer`

  return (
    <ProgressBar
      testId={testId}
      progress={{
        value: progress,
        color: 'green30',
        TooltipProps: {
          title: formatMessage(
            {
              id: getTooltipI18nTitle(product, true)
            },
            {
              ...formatStyles.bold,
              serversCount: progress
            }
          ),
          body:
            product === 'ASSESS' && env === 'PRODUCTION' ? (
              <div>
                {formatMessage(
                  {
                    id: 'detail_prodEnv_assessSlowDownApp'
                  },
                  {
                    ...formatStyles.anchor,
                    a: (...msg) => (
                      <Link
                        href={formatMessage({
                          id: 'detail_prodEnv_assessPerformanceOptions_link'
                        })}
                        isExternal
                      >
                        {msg}
                      </Link>
                    )
                  }
                )}
              </div>
            ) : undefined
        }
      }}
      total={{
        value: total,
        TooltipProps: {
          title: formatMessage(
            {
              id: getTooltipI18nTitle(product, false)
            },
            {
              ...formatStyles.bold,
              serversCount: total - progress
            }
          )
        }
      }}
      labelType="side"
      customLabel={`${progress}/${total}`}
      LinkProps={{
        href: getServersFilteredRoute(organizationUuid, applicationId, env)
      }}
    />
  )
}

export const getTooltipI18nTitle = (
  product: ContrastProduct,
  isOn: boolean
) => {
  let i18nTitle = ''

  switch (product) {
    case 'PROTECT':
      i18nTitle = isOn
        ? 'detail_appOverview_featureProtectOn_forNServers'
        : 'detail_appOverview_featureProtectOff_forNServers'
      break
    case 'ASSESS':
      i18nTitle = isOn
        ? 'detail_appOverview_featureAssessOn_forNServers'
        : 'detail_appOverview_featureAssessOff_forNServers'
      break
  }

  return i18nTitle
}

export const reactServerThermometer = createNgReactBridgeDirective(
  'reactServerThermometer',
  [],
  ServerEnvProductBar,
  ['progress', 'total', 'product', 'organizationUuid', 'applicationId', 'env']
)
